var render = function render(_c, _vm) {
  return _c("div", { staticClass: "row roomy margin-bottom-4xl" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "column-12 tablet:column-8 laptop:column-7 position-relative",
      },
      [
        _c("h1", { staticClass: "margin-top-0 margin-bottom-md" }, [
          _vm._v("The Icon Requests Leaderboard"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "size-lg tablet:line-length-sm laptop:line-length-md margin-bottom-4xl",
          },
          [
            _c(
              "p",
              [
                _vm._v(
                  "\n        Many of our most popular icons started as a request from the Font Awesome Community. Keep track of the most popular\n        "
                ),
                _c(
                  "site-link",
                  { attrs: { to: { name: "leaderboard.new" } } },
                  [_vm._v("icon")]
                ),
                _vm._v("\n        and\n        "),
                _c(
                  "site-link",
                  { attrs: { to: { name: "leaderboard.brands" } } },
                  [_vm._v("brand")]
                ),
                _vm._v("\n        requests, and see which ones are\n        "),
                _c(
                  "site-link",
                  { attrs: { to: { name: "leaderboard.released" } } },
                  [_vm._v("being worked on")]
                ),
                _vm._v("\n        or\n        "),
                _c(
                  "site-link",
                  { attrs: { to: { name: "leaderboard.released" } } },
                  [_vm._v("just released")]
                ),
                _vm._v("!\n      "),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "p",
              [
                _vm._v("\n        Have an idea?\n        "),
                _c(
                  "site-link",
                  {
                    attrs: {
                      to: { name: "support", hash: "#requesting-icons" },
                    },
                  },
                  [_vm._v("Share your request")]
                ),
                _vm._v(" with the community!\n      "),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c("wa-carbon-ad"),
        _vm._v(" "),
        _c("img", {
          staticClass:
            "position-absolute display-none tablet:display-block laptop:display-none",
          staticStyle: {
            top: "-2em",
            right: "-35em",
            height: "22em",
            "max-width": "none",
          },
          attrs: {
            src: "https://img.fortawesome.com/1ce05b4b/leaderboard-illustration.svg",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function (_c, _vm) {
    return _c(
      "div",
      {
        staticClass:
          "column-12 margin-bottom-2xl tablet:margin-bottom-0 tablet:column-5 tablet:order-last text-center",
      },
      [
        _c("img", {
          staticClass:
            "display-inline-block tablet:display-none laptop:display-inline-block",
          attrs: {
            src: "https://img.fortawesome.com/1ce05b4b/leaderboard-illustration.svg",
            alt: "",
          },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }